import React from 'react';

import { translate } from '@vimeo/i18n-runtime';
import { CircleWarning, DismissX } from '@vimeo/iris/icons';

import { FileDownload } from '../types';

const warningTdStyle = {
  borderBottom: '1px solid #ebeef1',
};

const warningWrapperStyle = {
  margin: '10px 0',
};

type Props = {
  file: FileDownload;
  isDefrosting: boolean;
  fetchConfirmation: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  coldStorageClose: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const ColdStorageNotification = ({
  file,
  isDefrosting = false,
  fetchConfirmation,
  coldStorageClose,
}: Props) => (
  <tr>
    <td style={warningTdStyle} colSpan={3}>
      {isDefrosting ? (
        <div style={warningWrapperStyle} className="iris_notification iris_notification--success">
          <div className="iris_notification--success-icon">
            <CircleWarning className="iris_ic is--16" />
          </div>
          <div className="iris_notification-content-wrapper">
            {translate('We’re on it! Please check back later, as it could take a few hours.')}
          </div>
          <button
            className="iris_notification-close iris_notification-close--success iris_notification-close--top"
            type="button"
            onClick={coldStorageClose}
          >
            <DismissX className="iris_ic is--12" />
          </button>
        </div>
      ) : (
        <div style={warningWrapperStyle} className="iris_notification iris_notification--warning">
          <div className="iris_notification--warning-icon">
            <CircleWarning className="iris_ic is--16" />
          </div>
          <div className="iris_notification-content-wrapper">
            <h5 className="iris_notification-header">
              {translate('Original file is in the archive')}
            </h5>
            <p className="iris_notification-text">
              {translate(
                'Source files not accessed for 30 days are automatically stored in our secret underground storage archive. As such, it may take a few hours to retrieve the file. Still want the original source file?',
              )}
            </p>
            <a
              role="button"
              className="iris_notification-btn iris_btn iris_btn--yellow iris_btn--sm"
              href={file.link}
              onClick={fetchConfirmation}
            >
              {translate('Yes, fetch original file')}
            </a>
          </div>
          <button
            className="iris_notification-close iris_notification-close--warning iris_notification-close--top"
            type="button"
            onClick={coldStorageClose}
          >
            <DismissX className="iris_ic is--12" />
          </button>
        </div>
      )}
    </td>
  </tr>
);

export default ColdStorageNotification;
